import { useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export const newsCardSrc = (a) => (a?.social_url && a.hash ? `${API}/api/news/social/${a.hash}.png` : null);
export const blogCoverSrc = (a) => (a?.image_url && a.slug ? `${API}/api/blog/cover/${a.slug}.png` : null);
// Poster frame for any video served from /api/media/videos/<id>; null for other sources.
export const videoPosterSrc = (src, thumb = false) => {
  const m = /\/api\/media\/videos\/([a-z0-9-]+)/.exec(src || '');
  return m ? `${API}/api/media/posters/${m[1]}.webp${thumb ? '?size=thumb' : ''}` : null;
};
export const blogCardSrc = (a) => (a?.social_url && a.slug ? `${API}/api/blog/social/${a.slug}.png` : null);

// Renders nothing when there is no image or it fails to load, so the surrounding layout stays as before.
// linked: the image sits inside a link, so clicks, drags and context menus go to the link, never the image file.
export const SocialImage = ({ src, thumbs = true, alt, width, height, className = '', eager = false, linked = false, testId, onMissing }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  const props = thumbs
    ? { src: `${src}?size=thumb`, srcSet: `${src}?size=thumb 1x, ${src}?size=thumb2x 2x` }
    : { src };
  return (
    <img
      {...props}
      alt={alt || ''}
      width={width}
      height={height}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      className={linked ? `${className} pointer-events-none select-none` : className}
      draggable={linked ? false : undefined}
      onError={() => { setFailed(true); onMissing?.(); }}
      data-testid={testId}
    />
  );
};

export default SocialImage;
